import { IPromise } from 'angular';

import { RequestHelper } from '../../helpers/RequestHelper';
import { ResultHelper } from '../../helpers/ResultHelper';
import { ServerApiMapper } from '../../helpers/ServerModelHelper';
import { Module } from '../../Module';
import { Resource } from '../../resources/Resource';
import { ErrorNotifyingServer } from '../../services/ErrorNotifyingServer';
import { FetcherFactory } from '../../services/FetcherFactory';
import { IResult } from '../types/IResponse';
import { DeleteCustomizedViewsRequest } from './DeleteCustomizedViewsRequest';
import { GetCustomizedViewsRequest } from './GetCustomizedViewsRequest';
import { ICustomViewInfo } from './ICustomViewInfo';


export class CustomViews extends Resource<ICustomViewInfo> {

  public static $inject = ['ErrorNotifyingServer', 'FetcherFactory'];

  constructor(private ErrorNotifyingServer: ErrorNotifyingServer, FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetCustomizedViewsRequest,
      ServerApiMapper.customViews));
  }

  public del(ids: string[]): IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteCustomizedViewsRequest(idsBlock)),
      ResultHelper.combineResults);
  }
}

Module.instance().service('CustomViews', CustomViews);
